// src/pages/History/Modern/BritishEmpire.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/19th_Century_-_British_Empire.png';

function HistoryPageBritishEmpire() {
  return (
    <TopicPage
      topicKey="British Empire"
      title="History: British Empire"
      backgroundImage={bg}
      startRoute="/History-British-Empire-Go"
      scrollLabels={[
        "Colonial Expansion",
        "Trade and the Navy",
        "Cultural and Political Impact",
      ]}
      backRoute="/history-19th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageBritishEmpire;
